import gql from 'graphql-tag';

export const GET_TIPS_CATEGORIES = gql`
  query GetTipsCategories {
    getTipsCategories {
      _id
      name
    }
  }
`;

export const GET_TIPS_BY_CATEGORY = gql`
  query GetTipsByCategory($category: MOID!) {
    getTipsByCategory(category: $category) {
      _id
      title
      audio
      category {
        _id
        name
      }
      isPublished
      type
      content {
        html
        text
      }
    }
  }
`;
